<template>
  <Takeover active>
    <CheckoutHeader />
    <AlreadyHave />
  </Takeover>
</template>
<script setup lang="ts">
import Takeover from '@/components/shared/Takeover.vue'
import CheckoutHeader from '@/components/shared/header/CheckoutHeader.vue'
import AlreadyHave from '@/components/shared/screens/AlreadyHave.vue'
import { useHead } from '@unhead/vue'
import { useProductStore } from '@/store/ProductStore'
import { storeToRefs } from 'pinia'

const productStore = useProductStore()
const { productName } = storeToRefs(productStore)

useHead({
  title: () => `${productName.value} - Output`
})
</script>
